// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sguuBAAafaIpfh6gI2hI{margin-bottom:20px}.T7uC1fI2eTQ2451ZYJRX{padding:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"segments": `sguuBAAafaIpfh6gI2hI`,
	"empty": `T7uC1fI2eTQ2451ZYJRX`
};
export default ___CSS_LOADER_EXPORT___;
